import { computed } from 'vue';

import ViktorClient from '@/api/clients/viktorClient/ViktorClient';
/* CONSTS */
import { DEFAULT_PER_PAGE } from '@/api/constants';
/* STORES */
import { useAuthStore } from '@/stores/auth';
/* TYPES */
import type { PaginatedResponse } from '@/types/api/axios';
import type { BaseUser } from '@/types/users/users';

/**
 * Get list of recruiters who have invited at least one contact
 */
export function getInviteByRecruiters({ search, page }): Promise<PaginatedResponse<BaseUser[]>> {
  const authStore = useAuthStore();
  const authUuid = computed(() => authStore.getFullUser?.uuid);
  const params = {
    'search[user_data:slug_full_name]': search?.trim() || undefined,
    order: 'user_data.slug_full_name:asc',
    page,
    per_page: DEFAULT_PER_PAGE
  };
  return ViktorClient().get(`/recruiter/${authUuid.value}/sharepool_users/inviters`, { params });
}
